import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Conveyancing
 * @exports Service/Conveyancing
 * @description API Conveyancing Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Conveyancing {
	/**
	 * @static @name list
	 * @description Get a list of referrals
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post('conveyancing/list', payload);
	}

	/**
	 * @static @name post
	 * @description Add a new conveyancing resource
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post('conveyancing', payload);
	}
}
